import {
  FormControl,
  MenuItem,
  Select,
  ListItemText,
  InputLabel,
  Checkbox,
  OutlinedInput,
} from "@mui/material";

const ItemHeight = 48;
const ItemPaddingUp = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ItemHeight * 4.5 + ItemPaddingUp,
      width: 250,
    },
  },
};

function MultipleSelect({ items, selectedItems, handleChange, label }) {
  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="items-multiple-checkbox-label">{label}</InputLabel>
        <Select
          labelId="items-multiple-checkbox-label"
          id="items-multiple-checkbox"
          multiple
          value={selectedItems}
          onChange={handleChange}
          input={<OutlinedInput label={label} />}
          renderValue={(selected) =>
            selected.map((item) => item.name).join(", ")
          }
          MenuProps={MenuProps}
        >
          {items.map((item) => (
            <MenuItem key={item.id} value={item}>
              <Checkbox checked={selectedItems.indexOf(item) > -1} />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}

export default MultipleSelect;
